import { render, staticRenderFns } from "./SalesRules.vue?vue&type=template&id=026d513e&scoped=true"
import script from "./SalesRules.vue?vue&type=script&lang=js"
export * from "./SalesRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@0.28.11_lodash@4.17.23_vue-t_lre32xywqxiddeo252btsfuiei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d513e",
  null
  
)

export default component.exports